import React, { Fragment as Frag } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { makeStyles, Grid, Typography, Tooltip } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  keywordContainer: {
    borderStyle: "solid",
    borderWidth: "3px",
    borderColor: "#ededed",
    borderRadius: "12px",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
  },

  iconContainer: {
    paddingRight: theme.spacing(1.3),
  },

  icon: {
    fontSize: "1.5em",
    color: theme.palette.primary.main,
  },

  title: {
    paddingBottom: "2px",
  },
}));

const toolTipText = `When viewing language matches in Digital Threat Detection, we search through 2.5 billion phrases, 
  rather than just keywords. As a result, you’ll see sentences broken down into individual words, 
  separated by commas for a fuller picture and better context as to why the alert was delivered. 
  To quickly identify the specific sentences, you can cross-reference them against the authored 
  text using Control+F`;

function KeywordsMatchesPanel(props) {
  let classes = styles(),
    { matches } = props;

  return (
    <Grid container direction="row" justifyContent="flex-start" wrap="nowrap" className={classes.keywordContainer}>
      <Grid item className={classes.iconContainer}>
        <Tooltip placement="top" title={toolTipText}>
          <div>
            <FontAwesomeIcon title="circle-exclamation" icon={["fas", "exclamation-circle"]} className={classes.icon} />
          </div>
        </Tooltip>
      </Grid>
      <Grid item>
        <Typography className={classes.title}>Why was this signal delivered?</Typography>
        {matches.length > 0 ? (
          <Frag>
            <Typography>Language Match Identified:</Typography>
            {matches.map((match) => (
              <div key={match}>
                <b>{match}</b>
              </div>
            ))}
          </Frag>
        ) : null}
      </Grid>
    </Grid>
  );
}

KeywordsMatchesPanel.propTypes = {
  matches: PropTypes.array,
};

export default KeywordsMatchesPanel;
